// TODO: AP-26869 Refactor this entire util into new package

export let SupportedCountry = /*#__PURE__*/function (SupportedCountry) {
  SupportedCountry["AU"] = "AU";
  SupportedCountry["CA"] = "CA";
  SupportedCountry["ES"] = "ES";
  SupportedCountry["FR"] = "FR";
  SupportedCountry["GB"] = "GB";
  SupportedCountry["IE"] = "IE";
  SupportedCountry["JP"] = "JP";
  SupportedCountry["US"] = "US";
  return SupportedCountry;
}({});
export let SupportedLocales = /*#__PURE__*/function (SupportedLocales) {
  SupportedLocales["EN_AU"] = "en-AU";
  SupportedLocales["EN_CA"] = "en-CA";
  SupportedLocales["FR_CA"] = "fr-CA";
  SupportedLocales["CA_ES"] = "ca-ES";
  SupportedLocales["ES_ES"] = "es-ES";
  SupportedLocales["FR_FR"] = "fr-FR";
  SupportedLocales["EN_GB"] = "en-GB";
  SupportedLocales["EN_IE"] = "en-IE";
  SupportedLocales["JA_JP"] = "ja-JP";
  SupportedLocales["EN_US"] = "en-US";
  SupportedLocales["ES_US"] = "es-US";
  return SupportedLocales;
}({});

// This list is used for tests and in customer directory
export const SUPPORTED_COUNTRIES = Object.values(SupportedCountry);
const ALTERNATE_ZIPCODE_VALIDATIONS = {
  [SupportedCountry.JP]: [/^\d{7}$/]
};

// Countries that use states in addresses (excluded countries: Japan uses prefectures; the UK and France do not use states)
export const COUNTRIES_WITH_STATE = [SupportedCountry.AU, SupportedCountry.CA, SupportedCountry.ES, SupportedCountry.IE, SupportedCountry.US];

// Countries that invert the city and zipcode
export const ZIPCODE_FIRST_COUNTRIES = [SupportedCountry.FR, SupportedCountry.ES];
export const ZIPCODE_VALIDATIONS = {
  [SupportedCountry.AU]: /^\d{3,4}$/,
  [SupportedCountry.CA]: /.+/,
  [SupportedCountry.ES]: /^\d{5}$/,
  [SupportedCountry.FR]: /^\d{5}$/,
  [SupportedCountry.GB]: /^[A-Z]{1,2}\d[\dA-Z]? ?\d[A-Z]{2}$/,
  [SupportedCountry.IE]: /^([AC-FHKNPRTV-Y]\d{2}|D6W) ?[\dAC-FHKNPRTV-Y]{4}$/,
  [SupportedCountry.JP]: /^\d{3}-\d{4}$/,
  [SupportedCountry.US]: /^\d{5}(-\d{4})?$/
};
export function isValidZipcode(value, countryCode = 'US', strictFormat = true) {
  const validator = ZIPCODE_VALIDATIONS[countryCode];
  const alternateValidators = ALTERNATE_ZIPCODE_VALIDATIONS[countryCode];
  if (strictFormat || !alternateValidators) {
    return validator && validator.test(value);
  }
  const validators = [validator, ...alternateValidators];
  return validators.some(v => v.test(value));
}